// extracted by mini-css-extract-plugin
export default {"parallax":"parallax_parallax__TibLi"};